<template>
  <v-alert
    text
    outlined
  >
    <h4 class="headline" style="font-size: 22px !important;">{{ $t('settings.info.recommendations') }}</h4>
    <br>
    <v-layout
      wrap
    >
      <v-flex xs2>
        <v-icon >mdi-image-area</v-icon>
      </v-flex>
      <v-flex xs10>
        <p class="titleNota">{{$t('settings.info.logo.title')}}</p>
        <p class="descriptionNota">{{$t('settings.info.logo.description')}}</p>
        <v-divider />
        <br />
      </v-flex>
      <v-flex xs2>
        <v-icon >mdi-image-move</v-icon>
      </v-flex>
      <v-flex xs10>
        <p class="titleNota">{{$t('settings.info.carousel.title')}}</p>
        <p class="descriptionNota">{{$t('settings.info.carousel.description')}}</p>
        <v-divider />
        <br />
      </v-flex>
      <v-flex xs2>
        <v-icon >mdi-routes</v-icon>
      </v-flex>
      <v-flex xs10>
        <p class="titleNota">{{$t('settings.info.language.title')}}</p>
        <p class="descriptionNota">{{$t('settings.info.language.description')}}</p>
        <!-- <v-divider /> -->
      </v-flex>
    </v-layout>
  </v-alert>
</template>

<script>
  export default {
    props: {
      onAdd: {
        type: Function,
        required: false,
        default: null
      }
    },
    computed: {
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      }
    },
  }
</script>
<style >
  .titleNota {
    font-size: 18px !important;
  }
  .descriptionNota {
    margin-top: -10px;
    font-size: 14px;
  }
</style>